import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { Groupe } from '../models/groupe.model';
import { avecMéthodesGroupes } from './groupe.methods';

export const GroupeStore = signalStore({ providedIn: 'root' }, withEntities<Groupe>(), avecMéthodesGroupes());
